export const languages = [
    { code: 'en', name: 'English', nativeName: 'English', prefix: 'A' },
    { code: 'ru', name: 'Russian', nativeName: 'Русский', prefix: 'Р' },
    // { code: 'es', name: 'Spanish', nativeName: 'Español', prefix: 'E' },
    // { code: 'zh', name: 'Chinese', nativeName: '中文', prefix: '中' },
    // { code: 'ja', name: 'Japanese', nativeName: '日本語', prefix: '日' },
    { code: 'ar', name: 'Arabic', nativeName: 'العربية', prefix: 'ع' },
    { code: 'fr', name: 'French', nativeName: 'Français', prefix: 'F' },
    { code: 'de', name: 'German', nativeName: 'Deutsch', prefix: 'G' },
    // { code: 'pt', name: 'Portuguese', nativeName: 'Português', prefix: 'P' },
    // { code: 'it', name: 'Italian', nativeName: 'Italiano', prefix: 'I' },
    // { code: 'ko', name: 'Korean', nativeName: '한국어', prefix: '한' },
    // { code: 'mfe', name: 'Mauritian Creole', nativeName: 'Kreol Morisien', prefix: 'K' },
    // { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', prefix: 'D' },
];